import generateMap from '../assets/elements/__elementMap';

let isGeneratedElementMap = false;
let elementMap = new Map();
let isGeneratedExtractedElementMap = false;
const extractedElementMap = new Map();

let templatesList;
let isGeneratedTemplatesList = false;

const thumbnailsPath = "./img/templateThumbnails/";

function getAllTemplates() {
    if(!isGeneratedTemplatesList) {
        templatesList = require('./templates.js').default;
        isGeneratedTemplatesList = true;
    }
    return templatesList;
}

//Function return (key: element_name, value: element_config) Map
function extractElementMap() {
    if(!isGeneratedExtractedElementMap) {
        if(!isGeneratedElementMap) {
            elementMap = generateMap();
            isGeneratedElementMap = true;
        }
        for (const [key, value] of elementMap)
        {
            const globalElements = require('../assets/elements.json').globalTypes;
            const withTypesObject = {};
            globalElements.forEach(element => {
                if (value[element] && Object.keys(value[element]).length > 0) {
                    const elementType = value[element].id.slice(0, value[element].id.lastIndexOf('-'));
                    withTypesObject[element] = {
                        ...value[element],
                        type: elementType
                    }
                }
            });

            if (Object.keys(withTypesObject).length > 0) {
                extractedElementMap.set(value.id, Object.assign(value, {
                    type: key.split('/')[0],
                    ...withTypesObject
                }))
            } else {
                extractedElementMap.set(value.id, Object.assign(value, {type: key.split('/')[0]}));
            }
        }
    }
    isGeneratedExtractedElementMap = true;
    return extractedElementMap;
}

function getElementSettings(elements) {
    const retval = [];
    const elementMapData = extractElementMap();
    
    elements.forEach(element => {
        retval.push(elementMapData.get(`${element}`));
    })

    return retval;
}

function getColumnElementSettings() {
    const retval = [];
    const elementMapData = extractElementMap();

    elementMapData.forEach(element => {
        let listsNames = require('../assets/defSites.json');
        let isParentAdded = false;
        listsNames = listsNames.filter(site => site.listName).map(listNameSite => listNameSite.listName);
        listsNames.forEach(list => {
            if (this.state.selectedTemplate[list].some(listElement => listElement === element.id)) {
                isParentAdded = true;
            }
        });
        if (this.state.selectedTemplate.header === element.id || this.state.selectedTemplate.footer === element.id) {
            isParentAdded = true;
        }
        if(!isParentAdded) {
            return;
        }

        if (element.column && Object.keys(element.column).length > 0) {
            retval.push(element.column);
        }
    });

    return retval;
}

function getThumbnail(templateID)
{
    const templates = getAllTemplates();
    return thumbnailsPath + templates[templateID-1].thumbnail;
}

function getTheme(templateID)
{
    const templates = getAllTemplates();
    return templates[templateID-1].settings.theme;
}

function getTemplateName(templateID)
{
    const templates = getAllTemplates();
    return templates[templateID-1].templateDisplayName;
}

function changeRecomendedNameAndSetType(body, listName) {
    if (body.type !== 'newsSection') {
        return;
    }
    body.name = `${listName.replace(/Body/g, '')}-rec`;

    //Assign deafult type (2)
    const config = JSON.parse(body.config);
    config.Type = 2;
    body.config = JSON.stringify(config);
}

export {getAllTemplates, getElementSettings, getColumnElementSettings, getThumbnail, getTheme, getTemplateName, changeRecomendedNameAndSetType}